// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { paperclip16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-paperclip': IconPaperclip;
    }
}

/**
 * The icon component for the 'paperclip' icon
 */
export class IconPaperclip extends IconSvg {
    public constructor() {
        super(paperclip16X16);
    }
}

registerIconSvg('icon-paperclip', IconPaperclip);
export const iconPaperclipTag = 'nimble-icon-paperclip';
